import { Component, OnInit, Input } from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'

@Component({
    selector: 'app-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    animations: [
        trigger('smoothCollapse', [
            state('initial', style({
                height: '0',
                overflow: 'hidden',
                opacity: '0',
                visibility: 'hidden',
            })),
            state('final', style({
                overflow: 'hidden',
            })),
            transition('initial<=>final', animate('100ms')),
        ]),
        trigger('rotatedState', [state('default', style({ transform: 'rotate(0)' })), state('rotated', style({ transform: 'rotate(180deg)' })), transition('default <=> rotated', animate('100ms'))]),
    ],
    standalone: false
})
export class AccordionItemComponent implements OnInit {
  @Input() title: string
  showBody = false
  img = `<mdb-icon fas icon="user-alt"></mdb-icon>`

  constructor() {}

  ngOnInit() {}

  toggle() {
    this.showBody = !this.showBody
  }
}
